export const SUM_REGIONS = {
  EUROPE: 'EUROPE',
}

export const EUROPE_FEATURE_PLATFORM = 'olymp'

export const REGION_CURRENCIES = {
  AR: 'ARS',
  AZ: 'AZN',
  BD: 'BDT',
  BR: 'BRL',
  CO: 'COP',
  IN: 'INR',
  KG: 'KGS',
  KZ: 'KZT',
  RU: 'RUB',
  TR: 'TRY',
  UZ: 'UZS',
}

const EUROPE_REGION_ALIASES = new Set([SUM_REGIONS.EUROPE, 'EURO'])

export function isEuropeFeatureEnabled(platform = process.env.PLATFORM) {
  return platform === EUROPE_FEATURE_PLATFORM
}

export function normalizeRegionCode(region) {
  return String(region || '').toUpperCase()
}

export function getUserSumRegion(user) {
  return user?.sumRegion || user?.region || null
}

export function isEuropeRegion(region) {
  return EUROPE_REGION_ALIASES.has(normalizeRegionCode(region))
}

export function getCurrencyByRegion(region, fallbackCurrency = null) {
  return REGION_CURRENCIES[normalizeRegionCode(region)] || fallbackCurrency
}

export function normalizeSumRegionRules(payload) {
  if (!payload) {
    return null
  }

  return {
    rules: Array.isArray(payload?.rules)
      ? payload.rules
          .filter((rule) => rule?.sumRegion && Array.isArray(rule?.regions))
          .map((rule) => ({
            sumRegion: normalizeRegionCode(rule.sumRegion),
            regions: rule.regions.map(normalizeRegionCode).filter(Boolean),
          }))
      : [],
    default: normalizeRegionCode(payload?.default) || null,
  }
}

export function getSumRegionByRegion(rulesPayload, region) {
  const normalizedRegion = normalizeRegionCode(region)

  if (!normalizedRegion) {
    return null
  }

  if (isEuropeRegion(normalizedRegion)) {
    return SUM_REGIONS.EUROPE
  }

  const rules = normalizeSumRegionRules(rulesPayload)
  if (!rules) {
    return null
  }

  const matchedRule = rules.rules.find((rule) => rule.regions.includes(normalizedRegion))

  return matchedRule?.sumRegion || rules.default || null
}
